import { render, staticRenderFns } from "./CragRouteVideos.vue?vue&type=template&id=670393d4"
import script from "./CragRouteVideos.vue?vue&type=script&lang=js"
export * from "./CragRouteVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports